
function copyCode(code, button) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(code).then(() => showCopyFeedback(button))
      .catch(() => fallbackCopy(code, button));
  } else {
    fallbackCopy(code, button);
  }
}

function fallbackCopy(code, button) {
  const textArea = document.createElement('textarea');
  textArea.value = code;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
  showCopyFeedback(button);
}

function showCopyFeedback(button) {
  button.classList.add('copied');
  const originalText = button.textContent;
  button.textContent = 'Copied!';
  setTimeout(() => {
    button.textContent = originalText;
    button.classList.remove('copied');
  }, 1500);
}
